<form #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate style="font-size:13px;">
  <div class="modal-header py-2">
    <h6 class="modal-title mb-0">{{ title | slice:0:1 | uppercase }}{{ title | slice:1 }}</h6>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body py-2 px-3">

    <!-- Infos hébergement -->
    <div class="row mb-2 g-1">
      <div class="col-md-4">
        <div class="border rounded px-2 py-1 bg-light">
          <div class="text-muted" style="font-size:11px;"><i class="fa fa-user me-1"></i>Client</div>
          <div class="fw-bold">{{ itemToSave.client_nom }} {{ itemToSave.client_prenom }}</div>
          <div class="text-muted" style="font-size:11px;">{{ itemToSave.client_telephone }}</div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="border rounded px-2 py-1 bg-light">
          <div class="text-muted" style="font-size:11px;"><i class="fa fa-concierge-bell me-1"></i>Service</div>
          <div class="fw-bold">{{ itemToSave.service_libelle }}</div>
          <div class="text-muted" style="font-size:11px;">{{ itemToSave.chambre_libelle }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="border rounded px-2 py-1 bg-light">
          <div class="text-muted" style="font-size:11px;"><i class="fa fa-sign-in-alt me-1"></i>Entrée</div>
          <div class="fw-bold">{{ itemToSave.date_debut | date:'dd/MM/yyyy HH:mm' }}</div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="border rounded px-2 py-1 bg-light">
          <div class="text-muted" style="font-size:11px;"><i class="fa fa-sign-out-alt me-1"></i>Sortie prévue</div>
          <div class="fw-bold">{{ itemToSave.date_fin | date:'dd/MM/yyyy HH:mm' }}</div>
        </div>
      </div>
    </div>

    <div class="row g-2">
      <!-- État hébergement -->
      <div class="col-lg-4">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <strong style="font-size:12px;">État hébergement</strong>
          <button type="button" class="btn btn-sm btn-outline-secondary py-0 px-1"
            *ngIf="itemsReglementHeberg.length"
            (click)="showReglementsHeberg = !showReglementsHeberg" style="font-size:11px;">
            <i class="fa" [class.fa-chevron-down]="!showReglementsHeberg" [class.fa-chevron-up]="showReglementsHeberg"></i>
            Règlements ({{ itemsReglementHeberg.length }})
          </button>
        </div>
        <hr class="my-1" />
        <div class="d-flex flex-column gap-1 mb-2">
          <div class="d-flex justify-content-between">
            <span class="text-muted">Montant total</span>
            <strong>{{ itemToSave.montant_total | IntegerFormatPipe }} FCFA</strong>
          </div>
          <div class="d-flex justify-content-between">
            <span class="text-muted">Total réglé</span>
            <strong class="text-success">{{ itemToSave.total_regle | IntegerFormatPipe }} FCFA</strong>
          </div>
          <div class="d-flex justify-content-between" *ngIf="itemToSave.total_remise > 0">
            <span class="text-muted">Remise</span>
            <strong class="text-warning">{{ itemToSave.total_remise | IntegerFormatPipe }} FCFA</strong>
          </div>
          <div class="d-flex justify-content-between">
            <span class="text-muted">Reste à régler</span>
            <strong [class.text-danger]="itemToSave.reste_a_regler > 0" [class.text-success]="itemToSave.reste_a_regler === 0">
              {{ itemToSave.reste_a_regler | IntegerFormatPipe }} FCFA
            </strong>
          </div>
        </div>
        <button type="button" (click)="openDialog('edit')" class="btn btn-primary btn-sm w-100 mb-1">
          <i class="fa fa-credit-card me-1"></i> Régler hébergement
        </button>
        <input type="hidden" name="montant_total" [(ngModel)]="itemToSave.montant_total" required />
        <input type="hidden" name="total_regle" [(ngModel)]="itemToSave.total_regle" required />
        <input type="hidden" name="total_remise" [(ngModel)]="itemToSave.total_remise" />
        <input type="hidden" name="reste_a_regler" [(ngModel)]="itemToSave.reste_a_regler" required />
      </div>

      <!-- Conso restaurant + boutique empilées -->
      <div class="col-lg-8 d-flex flex-column gap-2">

        <!-- Conso restaurant -->
        <div>
          <strong style="font-size:12px;">Conso restaurant</strong>
          <hr class="my-1" />
          <div *ngIf="livraisonsRestau.length === 0" class="text-muted" style="font-size:11px;">Aucune consommation</div>
          <div class="table-responsive" *ngIf="livraisonsRestau.length > 0">
            <table class="table table-sm mb-0" style="font-size:11px;">
              <thead class="table-light"><tr><th style="width:20px;"></th><th>Réf.</th><th class="text-end">Montant</th><th class="text-end">Réglé</th><th class="text-end">Reste</th><th style="width:80px;"></th></tr></thead>
              <tbody>
                <ng-container *ngFor="let liv of livraisonsRestau">
                  <tr style="cursor:pointer;" (click)="toggleDetail(liv)">
                    <td class="text-center"><span *ngIf="loadingDetailId === liv.id" class="spinner-border spinner-border-sm text-secondary" style="width:10px;height:10px;"></span><i *ngIf="loadingDetailId !== liv.id" class="fa" [class.fa-chevron-down]="!isExpanded(liv.id)" [class.fa-chevron-up]="isExpanded(liv.id)"></i></td>
                    <td><small>{{ liv.codification }}</small></td>
                    <td class="text-end">{{ liv.montant_total | IntegerFormatPipe }}</td>
                    <td class="text-end text-success">{{ liv.total_regle | IntegerFormatPipe }}</td>
                    <td class="text-end"><span [class.text-danger]="liv.reste_a_regler > 0">{{ liv.reste_a_regler | IntegerFormatPipe }}</span></td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <button type="button" class="btn btn-primary btn-sm py-0 px-1" style="font-size:10px;" [disabled]="liv.reste_a_regler <= 0" (click)="$event.stopPropagation(); openReglementLivraison(liv)">Régler</button>
                        <button *ngIf="liv.total_regle > 0" type="button" class="btn btn-outline-secondary btn-sm py-0 px-1" style="font-size:10px;" (click)="$event.stopPropagation(); toggleReglements(liv)"><i class="fa fa-history"></i></button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="isExpanded(liv.id)"><td colspan="6" class="p-0 bg-light"><div class="px-2 py-1"><div *ngIf="!livraisonDetails[liv.id]?.length" class="text-muted fst-italic" style="font-size:11px;">Aucun détail</div><table *ngIf="livraisonDetails[liv.id]?.length" class="table table-xs table-bordered mb-0" style="font-size:11px;"><thead class="table-secondary"><tr><th>Article</th><th class="text-end">Qté</th><th class="text-end">P.U</th><th class="text-end">Montant</th></tr></thead><tbody><tr *ngFor="let det of livraisonDetails[liv.id]"><td>{{ det.menu_libelle || det.article_libelle || det.libelle }}</td><td class="text-end">{{ det.quantite_livraison }}</td><td class="text-end">{{ det.prix_unitaire | IntegerFormatPipe }}</td><td class="text-end">{{ det.montant_livraison | IntegerFormatPipe }}</td></tr></tbody></table></div></td></tr>
                  <tr *ngIf="isExpandedReglements(liv.id)"><td colspan="6" class="p-0"><div class="px-2 py-1 bg-white"><div *ngIf="!reglementLivraisonMap[liv.id]?.length" class="text-muted fst-italic" style="font-size:11px;">Aucun règlement</div><table *ngIf="reglementLivraisonMap[liv.id]?.length" class="table table-xs table-bordered mb-0" style="font-size:11px;"><thead class="table-info"><tr><th>Mode</th><th>Caisse</th><th class="text-end">Montant</th><th class="text-end">Reçu</th><th>Date</th></tr></thead><tbody><tr *ngFor="let reg of reglementLivraisonMap[liv.id]"><td>{{ reg.mode_reglement_libelle }}</td><td>{{ reg.caisse_libelle }}</td><td class="text-end text-success">{{ reg.montant | IntegerFormatPipe }}</td><td class="text-end">{{ reg.montant_recu | IntegerFormatPipe }}</td><td style="white-space:nowrap;">{{ reg.created_at | date:'dd/MM/yyyy HH:mm' }}</td></tr></tbody></table></div></td></tr>
                </ng-container>
              </tbody>
              <tfoot class="table-active fw-bold"><tr><td></td><td>Total</td><td class="text-end">{{ totalMontantRestau | IntegerFormatPipe }}</td><td class="text-end text-success">{{ totalRegleRestau | IntegerFormatPipe }}</td><td class="text-end" [class.text-danger]="totalResteRestau > 0">{{ totalResteRestau | IntegerFormatPipe }}</td><td></td></tr></tfoot>
            </table>
          </div>
        </div>

        <!-- Conso boutique -->
        <div>
          <strong style="font-size:12px;">Conso boutique</strong>
          <hr class="my-1" />
          <div *ngIf="livraisonsBoutique.length === 0" class="text-muted" style="font-size:11px;">Aucune consommation</div>
          <div class="table-responsive" *ngIf="livraisonsBoutique.length > 0">
            <table class="table table-sm mb-0" style="font-size:11px;">
              <thead class="table-light"><tr><th style="width:20px;"></th><th>Réf.</th><th class="text-end">Montant</th><th class="text-end">Réglé</th><th class="text-end">Reste</th><th style="width:80px;"></th></tr></thead>
              <tbody>
                <ng-container *ngFor="let liv of livraisonsBoutique">
                  <tr style="cursor:pointer;" (click)="toggleDetail(liv)">
                    <td class="text-center"><span *ngIf="loadingDetailId === liv.id" class="spinner-border spinner-border-sm text-secondary" style="width:10px;height:10px;"></span><i *ngIf="loadingDetailId !== liv.id" class="fa" [class.fa-chevron-down]="!isExpanded(liv.id)" [class.fa-chevron-up]="isExpanded(liv.id)"></i></td>
                    <td><small>{{ liv.codification }}</small></td>
                    <td class="text-end">{{ liv.montant_total | IntegerFormatPipe }}</td>
                    <td class="text-end text-success">{{ liv.total_regle | IntegerFormatPipe }}</td>
                    <td class="text-end"><span [class.text-danger]="liv.reste_a_regler > 0">{{ liv.reste_a_regler | IntegerFormatPipe }}</span></td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <button type="button" class="btn btn-primary btn-sm py-0 px-1" style="font-size:10px;" [disabled]="liv.reste_a_regler <= 0" (click)="$event.stopPropagation(); openReglementLivraison(liv)">Régler</button>
                        <button *ngIf="liv.total_regle > 0" type="button" class="btn btn-outline-secondary btn-sm py-0 px-1" style="font-size:10px;" (click)="$event.stopPropagation(); toggleReglements(liv)"><i class="fa fa-history"></i></button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="isExpanded(liv.id)"><td colspan="6" class="p-0 bg-light"><div class="px-2 py-1"><div *ngIf="!livraisonDetails[liv.id]?.length" class="text-muted fst-italic" style="font-size:11px;">Aucun détail</div><table *ngIf="livraisonDetails[liv.id]?.length" class="table table-xs table-bordered mb-0" style="font-size:11px;"><thead class="table-secondary"><tr><th>Article</th><th class="text-end">Qté</th><th class="text-end">P.U</th><th class="text-end">Montant</th></tr></thead><tbody><tr *ngFor="let det of livraisonDetails[liv.id]"><td>{{ det.menu_libelle || det.article_libelle || det.libelle }}</td><td class="text-end">{{ det.quantite_livraison }}</td><td class="text-end">{{ det.prix_unitaire | IntegerFormatPipe }}</td><td class="text-end">{{ det.montant_livraison | IntegerFormatPipe }}</td></tr></tbody></table></div></td></tr>
                  <tr *ngIf="isExpandedReglements(liv.id)"><td colspan="6" class="p-0"><div class="px-2 py-1 bg-white"><div *ngIf="!reglementLivraisonMap[liv.id]?.length" class="text-muted fst-italic" style="font-size:11px;">Aucun règlement</div><table *ngIf="reglementLivraisonMap[liv.id]?.length" class="table table-xs table-bordered mb-0" style="font-size:11px;"><thead class="table-info"><tr><th>Mode</th><th>Caisse</th><th class="text-end">Montant</th><th class="text-end">Reçu</th><th>Date</th></tr></thead><tbody><tr *ngFor="let reg of reglementLivraisonMap[liv.id]"><td>{{ reg.mode_reglement_libelle }}</td><td>{{ reg.caisse_libelle }}</td><td class="text-end text-success">{{ reg.montant | IntegerFormatPipe }}</td><td class="text-end">{{ reg.montant_recu | IntegerFormatPipe }}</td><td style="white-space:nowrap;">{{ reg.created_at | date:'dd/MM/yyyy HH:mm' }}</td></tr></tbody></table></div></td></tr>
                </ng-container>
              </tbody>
              <tfoot class="table-active fw-bold"><tr><td></td><td>Total</td><td class="text-end">{{ totalMontantBoutique | IntegerFormatPipe }}</td><td class="text-end text-success">{{ totalRegleBoutique | IntegerFormatPipe }}</td><td class="text-end" [class.text-danger]="totalResteBoutique > 0">{{ totalResteBoutique | IntegerFormatPipe }}</td><td></td></tr></tfoot>
            </table>
          </div>
        </div>

      </div>
    </div>

    <!-- Règlements hébergement (pleine largeur) -->
    <div *ngIf="showReglementsHeberg && itemsReglementHeberg.length" class="mt-1">
      <div class="table-responsive">
        <table class="table table-xs table-bordered mb-0" style="font-size:11px;">
          <thead class="table-secondary">
            <tr><th>Mode</th><th>Caisse</th><th class="text-end">Montant</th><th class="text-end">Reçu</th><th class="text-end">Monnaie</th><th>Date</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let reg of itemsReglementHeberg" [class.table-warning]="reg.is_ristourne === 1">
              <td>{{ reg.mode_reglement_libelle }}<span *ngIf="reg.is_ristourne === 1" class="badge bg-warning text-dark ms-1" style="font-size:9px;">Ristourne</span></td>
              <td>{{ reg.caisse_libelle }}</td>
              <td class="text-end" [class.text-danger]="reg.is_ristourne === 1">{{ reg.is_ristourne === 1 ? '-' : '' }}{{ reg.montant | IntegerFormatPipe }}</td>
              <td class="text-end">{{ reg.montant_recu | IntegerFormatPipe }}</td>
              <td class="text-end">{{ reg.monnaie_rendue | IntegerFormatPipe }}</td>
              <td style="white-space:nowrap;">{{ reg.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          </tbody>
          <tfoot class="table-active fw-bold">
            <tr><td colspan="2">Total réglé</td><td class="text-end text-success" colspan="4">{{ itemToSave.total_regle | IntegerFormatPipe }} FCFA</td></tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Récap global -->
    <div class="mt-1" *ngIf="livraisonsRestau.length > 0 || livraisonsBoutique.length > 0">
      <div class="sc-recap" [class.sc-recap--du]="totalResteGlobal > 0">
        <div class="d-flex gap-3">
          <span>Hébergement : <strong>{{ itemToSave.reste_a_regler | IntegerFormatPipe }} FCFA</strong></span>
          <span *ngIf="livraisonsRestau.length > 0">Restaurant : <strong>{{ totalResteRestau | IntegerFormatPipe }} FCFA</strong></span>
          <span *ngIf="livraisonsBoutique.length > 0">Boutique : <strong>{{ totalResteBoutique | IntegerFormatPipe }} FCFA</strong></span>
        </div>
        <strong>Reste total : {{ totalResteGlobal | IntegerFormatPipe }} FCFA</strong>
      </div>
    </div>

    <!-- Raison sortie + perte sur une ligne -->
    <div class="d-flex align-items-start gap-2 mt-2">
      <div style="min-width:200px;">
        <label class="form-label mb-1" style="font-size:12px;">Raison sortie</label>
        <select class="form-select form-select-sm" name="raison_sortie_id" [(ngModel)]="itemToSave.raison_sortie_id"
          #raison_sortie_idCtrl="ngModel" required>
          <option *ngFor="let item of itemsRaisonSortie" [value]="item.id">{{ item.libelle }}</option>
        </select>
        <div *ngIf="raison_sortie_idCtrl.invalid && raison_sortie_idCtrl.touched" class="text-danger" style="font-size:11px;">Requis</div>
      </div>

      <!-- Bloc sortie avec perte -->
      <div *ngIf="totalResteGlobal > 0" class="flex-grow-1 sc-impaye" [class.sc-impaye--perte]="is_sortie_perte">
        <div class="d-flex justify-content-between align-items-center">
          <span style="font-size:12px;" class="text-danger fw-semibold">
            <i class="fa fa-exclamation-circle me-1"></i>Solde impayé : {{ totalResteGlobal | IntegerFormatPipe }} FCFA
          </span>
          <button type="button" class="btn btn-sm ms-2 py-0"
            [class.btn-outline-danger]="!is_sortie_perte"
            [class.btn-danger]="is_sortie_perte"
            style="font-size:11px;"
            (click)="is_sortie_perte = !is_sortie_perte">
            <i class="fa me-1" [class.fa-hand-holding-usd]="!is_sortie_perte" [class.fa-times]="is_sortie_perte"></i>
            {{ is_sortie_perte ? 'Annuler' : 'Comptabiliser comme perte' }}
          </button>
        </div>
        <div *ngIf="is_sortie_perte" class="row g-2 mt-1">
          <div class="col-8">
            <textarea class="form-control form-control-sm" rows="1" name="raison_perte" [(ngModel)]="raison_perte"
              placeholder="Raison de la perte (obligatoire)"></textarea>
          </div>
          <div class="col-4">
            <label class="btn btn-outline-secondary btn-sm w-100 mb-0 py-1" style="cursor:pointer;font-size:11px;">
              <i class="fa fa-paperclip me-1"></i>{{ justifImageName || 'Joindre justif.' }}
              <input type="file" hidden (change)="uploadJustif($event)" accept=".pdf,.jpg,.jpeg,.png">
            </label>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer py-2">
    <button type="button" (click)="activeModal.dismiss()" class="btn btn-sm btn-danger me-2">Fermer</button>
    <button type="submit" class="btn btn-sm"
      [class.btn-primary]="!is_sortie_perte"
      [class.btn-warning]="is_sortie_perte"
      [disabled]="form.invalid || (totalResteGlobal > 0 && !is_sortie_perte) || (is_sortie_perte && !raison_perte)">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
      <i class="fa me-1" [class.fa-save]="!is_sortie_perte" [class.fa-exclamation-triangle]="is_sortie_perte"></i>
      {{ is_sortie_perte ? 'Sortie avec perte' : 'Sauvegarder' }}
    </button>
  </div>
</form>
